const FETCH_DEFAULT_LOCATION = 'FETCH_DEFAULT_LOCATION';
const FETCH_DEFAULT_LOCATION_FULFILLED = 'FETCH_DEFAULT_LOCATION_FULFILLED';
const SET_IS_READY = 'SET_IS_READY';
const SET_IS_RELOAD_OK = 'SET_IS_RELOAD_OK';
const SET_MAP = 'SET_MAP';
const RESET_MAP = 'RESET_MAP';
const SET_LANGUAGE = 'SET_LANGUAGE';
const SET_SELECTED_ADDRESS = 'SET_SELECTED_ADDRESS';
const SET_SELECTED_PLACE = 'SET_SELECTED_PLACE';

export {
  FETCH_DEFAULT_LOCATION,
  FETCH_DEFAULT_LOCATION_FULFILLED,
  SET_LANGUAGE,
  SET_IS_READY,
  SET_IS_RELOAD_OK,
  SET_MAP,
  RESET_MAP,
  SET_SELECTED_ADDRESS,
  SET_SELECTED_PLACE,
};
